import GetMetric, { AggregationFunction } from './GetMetric';
import { DateRange } from '../../redux/dateRangeSlice';
import { Metric } from '../../constants/Types';

const GetUtilitiesMetricByDate = async (range: DateRange, deviceNumId?: string) => {
  try {
    const res = await Promise.all([
      GetMetric({
        metric: Metric.ELECTRICITY,
        range,
        deviceNumId,
        aggregationFunction: AggregationFunction.SUM,
      }),
      GetMetric({
        metric: Metric.GAS,
        range,
        aggregationFunction: AggregationFunction.SUM,
      }),
      GetMetric({
        metric: Metric.WATER,
        range,
        aggregationFunction: AggregationFunction.SUM,
      }),
      GetMetric({
        metric: Metric.CO2,
        range,
        aggregationFunction: AggregationFunction.SUM,
      }),
    ]);
    return res;
  } catch {
    return null;
  }
};

export default GetUtilitiesMetricByDate;
